export function obfuscateBankAccountNumber(transit: string, institution: string, account: string): string {
  const obfuscatedAccount = '*'.repeat(3).concat(account.slice(3));
  return `${transit}-${institution}-${obfuscatedAccount}`;
}
